import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  cardContent: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  }
}));